module.exports = __webpack_public_path__ + "img/fb-social-icon.aa8f8edd.svg";